import React from "react";

export default function Banner({ children }) {
  return <div class="hero-banner">{children}</div>;
}
